module.exports = __webpack_public_path__ + "media/images/event/image_05-f0a1d3c40d46ae7bccebadd3de64e5e2.png";